import React, { Component } from "react";
import IngredientAdmin from "./IngredientAdmin"; // Import the ingredient admin component
import RecipeAdmin from "./RecipeAdmin"; // Import recipe admin component later
import SearchBar from "./SearchBar"; // Adjust path

// Define the main selector component
export default class IngredientRecipeAdminSelector extends Component {
  // Initialize state to show 'Ingredient' view by default
  state = {
    view: "Ingredient", // Can be 'Ingredient' or 'Recipe'
    searchResults: [],
    recipeCategories: [],
  };

  // Function to switch the view
  setView = (newView) => {
    this.setState({ view: newView });
  };

  setRecipeCategories = (recipeCategories) => {
    this.setState({ recipeCategories });
  };

  handleSearchResults = (results) => {
    this.setState({ searchResults: results });
    // Now you can do whatever you want with the results, e.g., render a list
    console.log("Received search results in parent:", results);
  };

  render() {
    const { view } = this.state; // Destructure state for cleaner access

    // Common button style, adjust highlight based on active view
    const getButtonStyle = (buttonView) => ({
      fontSize: "20px",
      border: view === buttonView ? "3px solid #5dab71" : "1px solid #dbdbdb", // Highlight active
      color: view === buttonView ? "#5dab71" : "#363636", // Highlight active text
      background: "white",
      borderRadius: "12px",
      padding: "5px 10px",
      cursor: "pointer",
      marginRight: "10px", // Add spacing between buttons
    });

    return (
      <>
        {/* Using Bulma section/container structure like the original */}
        <section className="section">
          <div className="container">
            {/* Main Title for the Admin Section */}
            <h1>Administrer Ingredienser og Opskrifter</h1>
            <br />
            {/* Button to select the Ingredient Admin view */}
            <button
              style={getButtonStyle("Ingredient")}
              onClick={() => this.setView("Ingredient")}
            >
              Ingredienser
            </button>
            {/* Button to select the Recipe Admin view */}
            <button
              style={getButtonStyle("Recipe")}
              onClick={() => this.setView("Recipe")}
            >
              Opskrifter
            </button>
            <br />
            <br /> {/* Add extra space before the content */}
            <SearchBar
              initialLanguage="da" // Optional: set initial language
              onResults={this.handleSearchResults} // Callback to receive results
              recipeCategories={this.state.recipeCategories}
            />
            <div className="results-display-area" style={{ marginTop: "20px" }}>
              <h2>Search Results:</h2>
              {this.state.searchResults.length > 0 ? (
                <ul>
                  {this.state.searchResults.map((item) => (
                    <li
                      style={{
                        borderWidth: 1,
                        borderColor: "black",
                        borderBlockStyle: "solid",
                        borderBottomWidth: 0,
                        marginBottom: 10,
                      }}
                      key={item.id || item.pk}
                    >
                      <h3>
                        {item.name || item.name_en} ({item.entityType})
                      </h3>
                      <p>Score: {item.score?.toFixed(2)}</p>
                      {item.totalKgCO2e && <p>KGCO2: {item.totalKgCO2e}</p>}
                      {item.co2e?.totalKg && <p>KGCO2: {item.co2e.totalKg}</p>}
                      {item.highlight &&
                        Object.entries(item.highlight).map(([key, value]) => (
                          <p
                            key={key}
                            style={{ fontSize: "0.8em", fontStyle: "italic" }}
                          >
                            <strong>{key}:</strong>{" "}
                            <span
                              style={{ fontStyle: "normal" }}
                              dangerouslySetInnerHTML={{ __html: value[0] }}
                            />
                          </p>
                        ))}
                    </li>
                  ))}
                </ul>
              ) : (
                <p>Type in the search bar to see results.</p>
              )}
            </div>
            <br />
            <br />
            {/* Conditional rendering based on the current view state */}
            {view === "Ingredient" ? (
              // Render the IngredientAdmin component if view is 'Ingredient'
              <IngredientAdmin />
            ) : (
              <RecipeAdmin
                setRecipeCategories={this.setRecipeCategories}
                recipeCategories={this.state.recipeCategories}
              />
            )}
          </div>
        </section>
      </>
    );
  }
}
